import React from 'react'

import { Pill } from '@/components/pills/Pill'
import { isPassResult, isFailResult, aiResponseToPassFail } from '@/utils/promptFeedback.helpers'

function getResponsePillProps(response) {
  if (isPassResult(response)) return { success: true }
  if (isFailResult(response)) return { critical: true }
  return {}
}

/**
 * Component to display expanded test result details
 */
export const TestResultDetails = ({ result, mustBePresent }) => {
  return (
    <div className="test-result-details">
      <div className="test-result-header">
        <h4>Test Results</h4>
      </div>

      <div className="test-result-comparison">
        <div className="test-result-columns">
          <div className="test-result-column">
            <div className="test-result-label">Expected</div>
            <div className="test-result-value">
              <Pill xs outlined {...getResponsePillProps(result.expected_response)}>
                {aiResponseToPassFail(result.expected_response, mustBePresent)}
              </Pill>
            </div>
          </div>

          <div className="test-result-column">
            <div className="test-result-label">Actual</div>
            <div className="test-result-value">
              <Pill xs emphasized {...getResponsePillProps(result.actual_response)}>
                {aiResponseToPassFail(result.actual_response, mustBePresent)}
              </Pill>
            </div>
          </div>
        </div>
      </div>

      <div className="test-result-section">
        <div className="test-result-label">Full AI Response</div>
        <pre className="ai-response-pre">
          {typeof result.actual_response === 'string'
            ? result.actual_response
            : JSON.stringify(result.actual_response, null, 2)}
        </pre>
      </div>

      {(result.tokens_used || result.executed_model) && (
        <div className="test-result-footer">
          {result.tokens_used && <span>Tokens: {result.tokens_used}</span>}
          {result.executed_model && <span>Model: {result.executed_model}</span>}
        </div>
      )}
    </div>
  )
}
